import { useSnapshot } from 'valtio'
import cn from 'classnames'
import format from 'date-fns/format'
import { type ReactElement } from 'react'
import { transactionsProxy } from '../../../../../../shared/proxies/transactionsProxy'
import { buildAppTransactionPath } from '../../../../../../pages/app/transactions/[id]'
import { AmountCell } from '../AmountCell/AmountCell'
import { buildAppCustomerPath } from '../../../../../../pages/app/customers/[id]'
import TransactionStatusLabel from '../../../../../../shared/components/ui/TransactionStatusLabel'
import { TableCell } from './TableCell'

export function TransactionsRows (): ReactElement {
  const { transactions } = useSnapshot(transactionsProxy)
  return (
    <>
      {transactions.length === 0 && (
        <tr>
          <td colSpan={10}>
            <div className="text-center my-16 text-wpy-gray">
              No Results
            </div>
          </td>
        </tr>
      )}
      {transactions.map((transaction, i) => {
        const notLastRow = i !== (transactionsProxy.transactions.length - 1)
        const path = buildAppTransactionPath(transaction.id)
        const customerPath = buildAppCustomerPath(transaction.customerId ?? '')

        return (
          <tr
            key={transaction.id}
            className={
              cn(
                'opacity-90 my-1 text-sm animate__animated animate__fadeIn',
                notLastRow && 'border-b border-gray-100'
              )
            }
          >
            <TableCell path={path}>
              {transaction.id}
            </TableCell>
            <TableCell path={path}>
              {format(new Date(transaction.transactedAt), 'MMM d, y')}
            </TableCell>
            <TableCell path={customerPath}>
              <div className="text-wpy-blue-600 text-ellipsis whitespace-nowrap overflow-hidden">
                {transaction.companyName}
              </div>
            </TableCell>
            <TableCell path={path}>
              {transaction.invoiceNumber}
            </TableCell>
            <TableCell path={path}>
              <div className="text-ellipsis whitespace-nowrap overflow-hidden">
                <TransactionStatusLabel status={transaction.status} />
              </div>
            </TableCell>
            <TableCell path={path}>
              {transaction.ppSslTransactionType}
            </TableCell>
            <TableCell path={path}>
              <AmountCell transaction={transaction} />
            </TableCell>
          </tr>
        )
      })}
    </>
  )
}
